/**
 * @file コンポーネント：チェックボックス DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledCheckbox,
    StyledCheckboxInput,
    StyledCheckboxText,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledCheckbox>
            <StyledCheckboxInput
                defaultChecked={props.defaultChecked}
                name={props.name}
                ref={props.refInputCheckbox}
                type="checkbox"
                value={props.value}
            />
            <StyledCheckboxText>{props.text}</StyledCheckboxText>
        </StyledCheckbox>
    );
};
